import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMutation } from '@apollo/react-hooks'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { updateObstacleData } from '../../actions'
import { CustomTableCell } from './CustomTableCell'
import { SAVE_OBSTACLE } from '../../queries/obstacle'
import EditIcon from '@mui/icons-material/EditOutlined'
import DoneIcon from '@mui/icons-material/DoneAllTwoTone'

function createData(id, name, feature, geom_guid, geojson) {
  return { id, name, feature, geom_guid, geojson, isEditMode: false }
}

const tableStyle = {
  minWidth: 350,
}

export default function ObstacleTable() {
  const { obstacles, selectedObstacle, remoteStorage, selectedScenarioId } =
    useSelector(state => state)
  const [rows, setRows] = useState([])
  const [previous, setPrevious] = useState({})
  const dispatch = useDispatch()
  const [saveObstacle] = useMutation(SAVE_OBSTACLE)

  useEffect(() => {
    if (obstacles.length > 0) {
      const data = obstacles
        .filter(obstacle => obstacle.scenario_id === selectedScenarioId)
        .map(o => createData(o.id, o.name, o.feature, o.geom_guid, o.geojson))
      setRows(data)
    } else {
      setRows([])
    }
  }, [obstacles, selectedScenarioId])

  const saveObstacleToDatabase = async input => {
    console.log(input)
    await saveObstacle({ variables: { input: input } })
  }

  const onDone = id => {
    setRows(() => {
      return rows.map(row => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode }
        }
        return row
      })
    })
    //let data = rows.filter(row => row.id === id)[0].name
    let data = rows.filter(row => row.id === id)[0]
    dispatch(updateObstacleData(id, data))
    if (remoteStorage.obstacles) {
      const input = {
        id: id.toString(),
        name: data.name,
      }
      saveObstacleToDatabase(input)
    }
  }

  const onToggleEditMode = id => {
    setRows(() => {
      return rows.map(row => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode }
        }
        return row
      })
    })
  }

  const onChange = (e, row) => {
    if (!previous[row.id]) {
      setPrevious(state => ({ ...state, [row.id]: row }))
    }
    const value = e.target.value
    const name = e.target.name
    const { id } = row
    const newRows = rows.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value }
      }
      return row
    })
    setRows(newRows)
  }

  const getRowStyle = row => {
    let style = {}
    selectedObstacle && row.geom_guid === selectedObstacle.geom_guid
      ? (style['background'] = '#EEEEEE')
      : null
    return style
  }

  // const onRowClick = row => {
  //   dispatch(selectObstacle(row.geom_guid))
  // }

  return (
    <TableContainer component={Paper}>
      <Table sx={tableStyle} size="small">
        <TableHead>
          <TableRow>
            <TableCell>Id</TableCell>
            <TableCell align="center">Name</TableCell>
            {/*<TableCell align="center">Actions</TableCell>*/}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.id} style={getRowStyle(row)}>
              <TableCell component="th" scope="row">
                {row.id}
              </TableCell>
              <CustomTableCell {...{ row, name: 'name', onChange }} />
              {/*<TableCell align="center">*/}
              {/*  {row.isEditMode ? (*/}
              {/*    <>*/}
              {/*      <IconButton*/}
              {/*        size="small"*/}
              {/*        aria-label="done"*/}
              {/*        onClick={() => onDone(row.id)}*/}
              {/*      >*/}
              {/*        <DoneIcon />*/}
              {/*      </IconButton>*/}
              {/*    </>*/}
              {/*  ) : (*/}
              {/*    <IconButton*/}
              {/*      size="small"*/}
              {/*      aria-label="edit"*/}
              {/*      onClick={() => onToggleEditMode(row.id)}*/}
              {/*    >*/}
              {/*      <EditIcon />*/}
              {/*    </IconButton>*/}
              {/*  )}*/}
              {/*</TableCell>*/}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
